import { Assets, Sprite, Texture, VideoResource } from 'pixi.js';
const PIXI_APP_SIZES = {
  // rendererSize: {
  //   width: 900,
  //   height: 500
  // },
  viewportSizes: null,
  clampMaxWidth: null,
  clampMaxHeight: null,
  clampMinWidth: null,
  clampMinHeight: null
};

const { app } = usePIXIAppInstance(PIXI_APP_SIZES);

export default () => {
  const createVideoResource = (videoName: string, container: Ref, isLooped?: boolean) => {
    const { isMobile } = useDevice();
    const texture = Assets.get(videoName);

    if (!texture) {
      throw new Error(`Texture not found for video: ${videoName}`);
    }

    const videoElement = texture.baseTexture.resource.source;
    videoElement.muted = true;
    videoElement.currentTime = 0;
    if (isLooped) {
      videoElement.loop = true;
      videoElement.playsInline = true;
    }

    const tavernWidth = container.value?.parentElement?.parentElement?.clientWidth || 0;
    const tavernHeight = container.value?.parentElement?.parentElement?.clientHeight || 0;

    const videoSprite = new Sprite(texture);

    if (isMobile) {
      videoSprite.width = texture.baseTexture.width * 1.5;
      videoSprite.height = tavernHeight;
      videoSprite.anchor.set(0.5, 0);
      videoSprite.x = tavernWidth;
    } else {
      videoSprite.width = tavernWidth;
      videoSprite.height = tavernHeight;
      app.renderer.resize(videoSprite.width, videoSprite.height);
    }

    const videoResource = videoSprite.texture.baseTexture.resource as VideoResource;

    return { app, videoResource, videoSprite, tavernWidth, tavernHeight, videoElement };
  };

  const createVideoResourceIos = async (videoName: string, container: Ref, isLooped?: boolean) => {
    const { isMobile } = useDevice();

    const videoElement = document.createElement('video');
    const videoSrc = videoName.includes('.') ? videoName : `/${videoName}.mp4`;
    videoElement.src = videoSrc;
    videoElement.setAttribute('playsinline', '');
    videoElement.setAttribute('webkit-playsinline', '');
    videoElement.setAttribute('x5-playsinline', '');
    videoElement.muted = true;
    videoElement.preload = 'auto';
    videoElement.autoplay = false;

    videoElement.style.position = 'absolute';
    videoElement.style.opacity = '0';
    videoElement.style.pointerEvents = 'none';
    videoElement.style.width = '100%';
    videoElement.style.height = '100%';
    document.body.appendChild(videoElement);

    if (isLooped) {
      videoElement.loop = true;
      videoElement.playsInline = true;
    }

    await Promise.race([
      new Promise<void>((resolve) => {
        if (videoElement.readyState >= 1) {
          resolve();
        } else {
          videoElement.addEventListener('loadedmetadata', () => resolve(), { once: true });
          videoElement.load();
        }
      }),
      new Promise<void>((resolve) => {
        setTimeout(() => resolve(), 800);
      })
    ]);

    const videoTexture = Texture.from(videoElement);
    const videoSprite = new Sprite(videoTexture);

    const tavernWidth = container.value?.parentElement?.parentElement?.clientWidth || 0;
    const tavernHeight = container.value?.parentElement?.parentElement?.clientHeight || 0;

    if (isMobile) {
      videoSprite.width = videoTexture.baseTexture.width * 1.5;
      videoSprite.height = tavernHeight;
      videoSprite.anchor.set(0.5, 0);
      videoSprite.x = tavernWidth;
    } else {
      videoSprite.width = tavernWidth;
      videoSprite.height = tavernHeight;
      app.renderer.resize(videoSprite.width, videoSprite.height);
    }

    const videoResource = videoSprite.texture.baseTexture.resource as VideoResource;

    if (videoResource) {
      videoResource.autoUpdate = true;
    }

    return { app, videoResource, videoSprite, tavernWidth, tavernHeight, videoElement };
  };

  return { createVideoResource, createVideoResourceIos };
};
